import { render, staticRenderFns } from "./AppChat.vue?vue&type=template&id=205c6e7e&scoped=true&"
import script from "./AppChat.vue?vue&type=script&lang=ts&"
export * from "./AppChat.vue?vue&type=script&lang=ts&"
import style0 from "./AppChat.vue?vue&type=style&index=0&id=205c6e7e&prod&lang=scss&"
import style1 from "./AppChat.vue?vue&type=style&index=1&id=205c6e7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c6e7e",
  null
  
)

export default component.exports